import type {SlotGameStore} from "@gamzix/slot_core";

class ReelFrameComponent extends Game.src.component.BaseComponent {
    onGameReady() {
        super.onGameReady();
    }


    setParentGroup(obj, parentGroupName) {
        obj.parentGroup = game.render.layerGroups[parentGroupName];
    }

    setZOrder(obj, zOrder) {
        obj.zOrder = zOrder;
    }

    setParentGroupGameForGameMachineFrame() {
        const frame = game.tree.findByName('reel_frame.frame')

        this.setParentGroup(frame, "GAME");
        this.setZOrder(frame, 3);

        this.onChangeOrientation();
    }

    setParentGroupTopForGameMachineFrame() {
        const frame = game.tree.findByName('reel_frame.frame')
        this.setParentGroup(frame, "GAME");
        this.setZOrder(frame, 42);

        this.onChangeOrientation();
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store;
    }
    
    getFSMHandlers():any {
        return {
            SPIN: {
                enter: {
                    on: () => {
                        if(this.store.gameData.bonusGame.isPlaying()) return
                        this.setParentGroupTopForGameMachineFrame();
                    }
                },
                endSpin: {
                    on: () => {
                        if (this.store.gameData.bonusGame.isPlaying()) return 
                        this.setParentGroupGameForGameMachineFrame();
                    }
                }
            },

        }
    }
}

//@ts-ignore
Game.src.component.ReelFrameComponent = ReelFrameComponent;

